import { ChangeDetectionStrategy, Component, Inject, OnInit } from "@angular/core";
import { MatLegacyDialogConfig as MatDialogConfig, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogModule, MatLegacyDialogRef as MatDialogRef } from "@angular/material/legacy-dialog";
import { Store } from "@ngrx/store";
import { State } from "src/app/dave-data-module/State";
import { CommonModule } from "@angular/common";
import { AppButtonModule } from "src/app/dave-utils-module/app-button-module/app-button.module";
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';
import { MatLegacyButtonModule as MatButtonModule } from "@angular/material/legacy-button";
import { appMatDialogDefaultConfig } from "src/app/helper/helper";
import { TextareaModule } from "src/app/components/templates/textarea/textarea.module";
import { FileEntity } from "src/app/dave-data-module/entities/file.entity";
import { FileDataService } from "src/app/dave-data-module/services/file-data.service";
import { map, take } from "rxjs";
import { FilesActionTypes } from "src/app/dave-data-module/State/actions/files.actions";

export interface RemarkPopupComponentDialogData {
    FileId: number;
}

@Component({
    selector: 'app-remark-popup',
    templateUrl: './remark-popup.component.html',
    styleUrls: ['./remark-popup.component.scss'],
    standalone: true,
    imports: [
        CommonModule,
        AppButtonModule,
        MatLegacyDialogModule,
        FormsModule,
        ReactiveFormsModule,
        FontAwesomeModule,
        MatTooltipModule,
        MatButtonModule,
        TextareaModule
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})

export class RemarkPopupComponent implements OnInit {
    public static DefaultConfig: MatDialogConfig = {
        ...appMatDialogDefaultConfig,
        minWidth: '30vw',
        maxWidth: '50vw',
        maxHeight: 'calc(100vh - 3.5rem)',
        closeOnNavigation: true,
    };
    
    protected File$: Observable<FileEntity> = this.fs.GetFileById$(this.dialogData.FileId).pipe(map((file) => file))
    public FileForm = new FormGroup({
        Remark: new FormControl<string | null>(null),
    });

    constructor(
        @Inject(MAT_DIALOG_DATA) 
        public dialogData: RemarkPopupComponentDialogData,
        private dialogRef: MatDialogRef<RemarkPopupComponent>,
        private store: Store<State>,
        private fs: FileDataService,
    ) {}

    ngOnInit() {
        if(this.dialogData.FileId) {
            this.File$.pipe(
                take(1),
            ).subscribe((file) => {
                this.FileForm.controls.Remark.setValue(file.Remark);
            });
        }
    }

    Submit() {
        this.store.dispatch(
            FilesActionTypes.ModifyFileRequest({
                Payload: {
                    DocumentId: (this.dialogData.FileId).toString(),
                    Remark: this.FileForm.controls.Remark.value,
                    SetRemarkNull: !this.FileForm.controls.Remark.value
                },
            })
        );
        this.dialogRef.close();
    }
 }